module.exports = __webpack_public_path__ + "img/图片41.0eb97cb1.jpg";